<template>
  <div>
    <div v-if="kiosk && start" class="content">
      <div
        class="background"
        :class="{cover: kiosk.backgroundImage}"
        :style="{backgroundImage: kiosk.backgroundImage ? `url(${kiosk.backgroundImage})` : `url(${require('@/assets/img/background.jpeg')})`}"
      ></div>
      <transition name="fade">
        <Introduction @show-page="changePage('main')" v-if="page == 'introduction'" :kiosk="kiosk" />
      </transition>
      <transition name="fade">
        <Main @show-cannabis="showFlavor" :kiosk="kiosk" v-if="page == 'main'" :options="options" />
      </transition>
      <transition name="fade">
        <Cannabis @show-page="page = 'main'" v-if="page == 'cannabis'" :flavor="selectedFlavor" />
      </transition>
    </div>
    <div class="invalid" v-if="start && !kiosk">
      <div class="background"></div>
      <h2>Invalid Screen url</h2>
    </div>
  </div>
</template>

<script>
import { db } from "@/config/firebaseInit";
import Introduction from "@/views/Introduction.vue";
import Main from "@/views/Main.vue";
import Cannabis from "@/views/Cannabis.vue";

export default {
  components: {
    Introduction,
    Main,
    Cannabis
  },
  data() {
    return {
      start: false,
      options: [],
      kiosk: null,
      query: [],
      page: "introduction",
      selectedFlavor: {}
    };
  },
  async created() {
    if (this.$route.params.kiosk_slug) {
      const query = await db
        .collection("kiosk")
        .where("slug", "==", this.$route.params.kiosk_slug)
        .get();
      const kiosk = query.docs[0];
      this.kiosk = Object.assign({ id: kiosk.id }, kiosk.data());
      this.start = true;
    } else {
      this.start = true;
    }
  },
  watch: {
    kiosk() {
      this.$bind(
        "options",
        db
          .collection("cannabis")
          .where("kiosks", "array-contains", this.kiosk.id)
      );
    }
  },
  methods: {
    showFlavor(flavor) {
      this.page = "cannabis";
      this.selectedFlavor = flavor;
    },
    changePage(page) {
      this.page = null;
      setTimeout(() => {
        this.page = page;
      }, 500);
    }
  }
};
</script>

<style>
.invalid {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>